import { render, staticRenderFns } from "./SeriesCoverTile.vue?vue&type=template&id=38c3afc5&scoped=true&"
import script from "./SeriesCoverTile.vue?vue&type=script&lang=js&"
export * from "./SeriesCoverTile.vue?vue&type=script&lang=js&"
import style0 from "./SeriesCoverTile.vue?vue&type=style&index=0&id=38c3afc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3afc5",
  null
  
)

component.options.__file = "SeriesCoverTile.vue"
export default component.exports